//------------------------------------------------------
//		商品ページに必要なjsをまとめて読み込む
//------------------------------------------------------
global.$ = global.jQuery = require('jquery');

//--------------------------------
//		ヘッダや基本ルーチン
//--------------------------------
import "./js/tirakita_base_functions.js"

//--------------------------------
//		フローティングカート
//--------------------------------
import "./js/floating_cart.js"

//--------------------------------
//		商品ページ用のルーチン
//--------------------------------
import "./js/goods_page_functions.js"

//--------------------------------
//		セール用のタイマールーチン
//--------------------------------
import "./js/sale_timer.js"

//--------------------------------
//		AjaxSuggest2
//--------------------------------
import "./js/jquery.ajaxSuggest2.js"

//--------------------------------
//	OWLカルーセル	部分						
//--------------------------------
import "../vendor/js/owl/owl-carousel/owl.carousel.js";

//--------------------------------
//	photoswipe部分 2019年1月31日変更
//--------------------------------
import "./js/photoswipe.js";

//--------------------------------
//	Magnifier部分 2019年7月8日変更
//--------------------------------
import "./js/magnifier_tirakita.js";

//--------------------------------
//		LazyLoad
//--------------------------------
import "./js/jquery.lazy.js"

//--------------------------------
//		縮小するパンくずリスト
//--------------------------------
import "./js/jquery.rcrumbs.min.js"

//--------------------------------
//		賞味期限
//--------------------------------
import "./js/syoumi_kigen.js"


//--------------------------------
//		ファイルのUPLOAD
//--------------------------------
import "./js/dnd_file_upload.js"

//--------------------------------
//		クーポンIDをクリップボードにコピー
//--------------------------------
import "./js/autogenerate_coupon_id_copy.js"



